import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/teams')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Teams',
  }),
});

function RouteComponent() {
  return <Outlet />;
}
